import i18n, { type TFunction } from 'i18next'
import { initReactI18next } from 'react-i18next'

import { namespaces } from '@/infra/i18n/locales'
import { resources } from '@/infra/i18n/resources'

export type TLocalidade = 'pt-BR' | 'es-CL'

export const defaultNS = 'common'

export function setLocalidade(locale?: TLocalidade | null): Promise<TFunction> {
  return i18n.changeLanguage(locale ?? navigator.language)
}

i18n.use(initReactI18next).init({
  lng: navigator.language,
  supportedLngs: ['pt-BR', 'es-CL'],
  fallbackLng: {
    es: ['es-CL'],
    pt: ['pt-BR'],
    default: ['pt-BR'],
  },
  ns: namespaces,
  defaultNS,
  resources,
  interpolation: { escapeValue: false },
})

export { default } from 'i18next'
